export default __webpack_public_path__ + "static/media/IMG_2286.8262ed2a.JPG";